module.exports = __webpack_public_path__ + "img/bg-wallet-success-modal-light.92886115.webp";